module.exports = __webpack_public_path__ + "static/media/defaultTemplateMap.svg";